(ns frontend.ui.component.search-input.style
  (:require
   [frontend.ui.style.theme.core :refer [border-width color edge-size text-size]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))

(defn search-input
  []
  (with-meta
    {:width         "100%"
     :padding       (space-join [(edge-size :xsmall)
                                 (edge-size :small)])
     :font-size     (text-size :small :size)
     :font-family   "inherit"
     :border-radius "50px"
     :border        (space-join [(border-width :medium)
                                 "solid"
                                 (theme/color [:search-input :border :regular])])}
    {:pseudo
     {:hover
      {:outline "none"
       :border  (space-join [(border-width :medium)
                             "solid"
                             (theme/color [:search-input :border :hover])])}
      :focus
      {:outline "none"
       :border  (space-join [(border-width :medium)
                             "solid"
                             (theme/color [:search-input :border :focus])])}}}))

(defn container
  []
  (with-meta
    {:position "relative"}
    {}))

(defn search-icon
  []
  (with-meta
    {:position  "absolute"
     :right     "12px"
     :top       "8px"
     :font-size "24px"}
    {}))
